/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Provide_Rejection_ReasonInputs */

const en_samples_provide_rejection_reason = /** @type {(inputs: Samples_Provide_Rejection_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide a rejection reason`)
};

const es_samples_provide_rejection_reason = /** @type {(inputs: Samples_Provide_Rejection_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor proporcione una razon de rechazo`)
};

/**
* | output |
* | --- |
* | "Please provide a rejection reason" |
*
* @param {Samples_Provide_Rejection_ReasonInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_provide_rejection_reason = /** @type {((inputs?: Samples_Provide_Rejection_ReasonInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Provide_Rejection_ReasonInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_provide_rejection_reason(inputs)
	return es_samples_provide_rejection_reason(inputs)
});